Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default=function(ctx) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }

 var fieldsetLegendIds = ctx.instance.getFieldsetLegendIds ? ctx.instance.getFieldsetLegendIds() : ''; ;
__p += '\n';
 var isViewReadContext = ctx.instance.options && (ctx.instance.options.readOnly || ctx.instance.options.pdf); ;
__p += '\n';
 var viewAccessibleLabel = isViewReadContext && ctx.instance.getFormattedViewAccessibleLabel ? ctx.instance.getFormattedViewAccessibleLabel() : ''; ;
__p += '\n';
 var useAriaLabelOnly = isViewReadContext && viewAccessibleLabel; ;
__p += '\n';
 var ariaAttr = useAriaLabelOnly ? 'aria-label' : 'aria-labelledby'; ;
__p += '\n';
 var ariaValue = useAriaLabelOnly ? viewAccessibleLabel : ((fieldsetLegendIds ? fieldsetLegendIds + ' ' : '') + 'l-' + ctx.instance.id + '-' + ctx.component.key); ;
__p += '\n<div class="row" role="group" ref="dayContainer"\n  ';
 if (ctx.label.hidden) { ;
__p += '\n  aria-label="' +
((__t = (ctx.component.label)) == null ? '' : __t) +
'"\n  ';
 } else { ;
__p += '\n  ' +
((__t = (ariaAttr)) == null ? '' : __t) +
'="' +
((__t = (ariaValue)) == null ? '' : __t) +
'"\n  ';
 } ;
__p += '\n  ';
 if (ctx.component.description) { ;
__p += '\n  aria-describedby="d-' +
((__t = (ctx.instance.id)) == null ? '' : __t) +
'-' +
((__t = (ctx.component.key)) == null ? '' : __t) +
'"\n  ';
 } ;
__p += '\n  >\n  ';
 if (ctx.dayFirst && ctx.showDay) { ;
__p += '\n  <div class="col col-xs-3">\n    ';
 if (!ctx.component.hideInputLabels) { ;
__p += '\n    <label for="' +
((__t = (ctx.component.key)) == null ? '' : __t) +
'-day">' +
((__t = (ctx.t('day'))) == null ? '' : __t);
 if (ctx.component.fields.day.required) { ;
__p += '<span class="required-star" aria-hidden="true"> *</span>';
 } ;
__p += '</label>\n    ';
 } ;
__p += '\n    <div>' +
((__t = (ctx.day)) == null ? '' : __t) +
'</div>\n  </div>\n  ';
 } ;
__p += '\n  ';
 if (ctx.showMonth) { ;
__p += '\n  <div class="col col-xs-4">\n    ';
 if (!ctx.component.hideInputLabels) { ;
__p += '\n    <label for="' +
((__t = (ctx.component.key)) == null ? '' : __t) +
'-month">' +
((__t = (ctx.t('month'))) == null ? '' : __t);
 if (ctx.component.fields.month.required) { ;
__p += '<span class="required-star" aria-hidden="true"> *</span>';
 } ;
__p += '</label>\n    ';
 } ;
__p += '\n    <div>' +
((__t = (ctx.month)) == null ? '' : __t) +
'</div>\n  </div>\n  ';
 } ;
__p += '\n  ';
 if (!ctx.dayFirst && ctx.showDay) { ;
__p += '\n  <div class="col col-xs-3">\n    ';
 if (!ctx.component.hideInputLabels) { ;
__p += '\n    <label for="' +
((__t = (ctx.component.key)) == null ? '' : __t) +
'-day">' +
((__t = (ctx.t('day'))) == null ? '' : __t);
 if (ctx.component.fields.day.required) { ;
__p += '<span class="required-star" aria-hidden="true"> *</span>';
 } ;
__p += '</label>\n    ';
 } ;
__p += '\n    <div>' +
((__t = (ctx.day)) == null ? '' : __t) +
'</div>\n  </div>\n  ';
 } ;
__p += '\n  ';
 if (ctx.showYear) { ;
__p += '\n  <div class="col col-xs-5">\n    ';
 if (!ctx.component.hideInputLabels) { ;
__p += '\n    <label for="' +
((__t = (ctx.component.key)) == null ? '' : __t) +
'-year">' +
((__t = (ctx.t('year'))) == null ? '' : __t);
 if (ctx.component.fields.year.required) { ;
__p += '<span class="required-star" aria-hidden="true"> *</span>';
 } ;
__p += '</label>\n    ';
 } ;
__p += '\n    <div>' +
((__t = (ctx.year)) == null ? '' : __t) +
'</div>\n  </div>\n  ';
 } ;
__p += '\n</div>\n<input name="ctx.data[day]" type="hidden" class="form-control" lang="en" value="" ref="input">\n';
return __p
}